export default __webpack_public_path__ + "static/media/up_big_arrow_icon.4fd41a19.svg";